import React from "react";

export const DepartmentShape = (props) => {
  const { cx, cy, payload } = props;
  const deptName = payload.department.name;
  const color = payload.department.color || "#6b7280";

  return (
    <g>
      <circle
        cx={cx}
        cy={cy}
        r={7}
        fill={color}
        fillOpacity={0.6}
        stroke={color}
        strokeOpacity={0.8}
        strokeWidth={2}
      />
      <text
        x={cx}
        y={cy + 26}
        textAnchor="middle"
        className="fill-black dark:fill-white"
        fontSize={12}
        fontWeight="500"
      >
        {deptName}
      </text>
    </g>
  );
};

